function c(r) {
  return r == null ? void 0 : r.sort((t, n) => {
    var o, s;
    return ((o = t.order) != null ? o : 1 / 0) - ((s = n.order) != null ? s : 1 / 0);
  });
}
const u = (r) => {
  const t = Math.round(r / 60), n = Math.floor(t / 60), o = t - n * 60, s = n > 0 ? n + "h" : "", e = o > 0 ? o + "m" : "";
  return `${s} ${e}`.trim();
}, i = ({
  progress: r,
  duration: t
}) => {
  if (t)
    return Math.floor(r / t * 100);
};
export {
  i as c,
  u as f,
  c as s
};
//# sourceMappingURL=watchingProgress-3173d4fa.js.map
